<div class="projects-container">
  @if (isLoading()) {
    <div class="projects-list-loading">
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden"></span>
      </div>
      <span>{{ "general.loading" | translate }}</span>
    </div>
  }
  @for (project of projects(); track project.id) {
    <app-project-vertical-card
      [displayType]="displayType()"
      [project]="project"
      (onDetailsClicked)="onDetailsClicked.emit($event)"
    ></app-project-vertical-card>
  }
</div>
